import Vue from 'vue';
import moment from 'moment';
import VueMoment from 'vue-moment';
import 'moment/locale/en-gb';

Vue.use(VueMoment, {
  moment
});
